var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar-event",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M1.25,5.8V17.633A1.218,1.218,0,0,0,2.5,18.817h15a1.218,1.218,0,0,0,1.25-1.183V5.8ZM2.5,2.25A2.436,2.436,0,0,0,0,4.617V17.633A2.436,2.436,0,0,0,2.5,20h15A2.436,2.436,0,0,0,20,17.633V4.617A2.436,2.436,0,0,0,17.5,2.25Z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M7.075,0C7.254,0,7.4.5,7.4,1.125V2.25c0,.621-.146,1.125-.325,1.125s-.325-.5-.325-1.125V1.125C6.75.5,6.9,0,7.075,0Zm5.85,0c.179,0,.325.5.325,1.125V2.25c0,.621-.146,1.125-.325,1.125s-.325-.5-.325-1.125V1.125C12.6.5,12.746,0,12.925,0Z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M25.875,13.5h2.25a1.125,1.125,0,0,1,1.125,1.125v2.25A1.125,1.125,0,0,1,28.125,18h-2.25a1.125,1.125,0,0,1-1.125-1.125v-2.25A1.125,1.125,0,0,1,25.875,13.5Z",
    transform: "translate(-12.571 -6.857)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEvent);
export default __webpack_public_path__ + "static/media/calendar-event.aaaf138f63b25a9a094a8f01cee83623.svg";
export { ForwardRef as ReactComponent };